import React from "react";
import Header from "./Header";
import Body from "./Body"
import Footer from "./Footer";
import Seo from "./Seo";


function Home() {
   return (
      <div>
         <Seo
            title="Electronic Signature Software for Business | SignuluOne"
            description="Prepare, send, sign and track business documents with flexible signing workflows, signer verification and audit trails. Start a trial or explore Signulu."
            keywords="electronic signature software, business eSignature platform, legally binding electronic signatures, digital signing workflow, document audit trails, Signulu"
            canonical="https://signulu.signuluone.com/"
         />
         <Header />
         <Body />
         <Footer />
      </div>
   )
}
export default Home;